AOS.init();

var swiper = new Swiper(".section1_swiper", {
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    // autoHeight: true,
    autoplay: {
        delay: 10000,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});


var desktopNav = document.querySelector('.desktop_nav_container');
var desktopLogo = document.querySelector('.desktop_main_logo_container');


const obsCallback = function (entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting === false) {
            desktopNav.classList.add('sticky')
        }
        else desktopNav.classList.remove('sticky')
    });
}


const observer = new IntersectionObserver(obsCallback, {
    root: null,
    threshold: 0
})

observer.observe(desktopLogo)


// mobile_nav1

var menu1Btn = document.querySelector('.hamburger_svg');

menu1Btn.addEventListener('click', function (e) {
    // var target = e.target
    var menu1 = document.querySelector('.mobile_menu1');
    menu1.classList.toggle('open_menu1');

    // console.log(menu1.clientHeight);
    if (menu1.clientHeight) {
        menu1.style.height = 0;
    } else {
        var wrapper = document.querySelector('.mobile_menu1_ul');
        menu1.style.height = wrapper.clientHeight + "px";
    }
})

// mobile_nav2

var menu2Btn = document.querySelector('.sm_hamburger_svg')
var menuContainer = document.querySelector('.mobile_nav2_container ')

menu2Btn.addEventListener('click', function () {
    menuContainer.classList.toggle('open_container')
})


// dropDown

var desktopNav1 = document.querySelectorAll('.nav_ul li:nth-child(2)');
var desktopNav2 = document.querySelectorAll('.nav_ul li:nth-child(3)');
// var desktopDrop = document.querySelector('.desktop_dropDown')
var boutiquieCont = document.querySelector(".boutiquie_dropDown");
var impactCont = document.querySelector('.impact_dropDown');
var dropCross = document.querySelectorAll('.dropDown_cross');


const boutiquieOpen = function () {
    boutiquieCont.classList.add('open_dropDown')
}
const boutiquieClose = function () {
    boutiquieCont.classList.remove('open_dropDown')
}

const impactOpen = function () {
    impactCont.classList.add('open_dropDown')
}

const impactClose = function () {
    impactCont.classList.remove('open_dropDown')
}


desktopNav1.forEach(nav => {
    nav.addEventListener('mouseenter', function (e) {
        // desktopOpen()
        boutiquieOpen()
    })
})


desktopNav1.forEach(nav => {
    nav.addEventListener('mouseleave', function (e) {
        // desktopClose()
        boutiquieClose()
    })
})

boutiquieCont.addEventListener('mouseover', function () {
    boutiquieOpen()
})

boutiquieCont.addEventListener('mouseleave', function () {
    boutiquieClose()
})


// nav2


desktopNav2.forEach(nav => {
    nav.addEventListener('mouseenter', function (e) {
        var target = e.target.querySelector('a')
        // desktopOpen()
        impactOpen()
    })
})


desktopNav2.forEach(nav => {
    nav.addEventListener('mouseleave', function (e) {
        // desktopClose()
        impactClose()
    })
})

impactCont.addEventListener('mouseover', function (e) {
    impactOpen()
})

impactCont.addEventListener('mouseleave', function (e) {
    impactClose()
})

dropCross.forEach(cross => {
    cross.addEventListener('click', function () {
        boutiquieClose()
        impactClose()
    })
});



var section4 = document.querySelector('.home_section4_container');

if (section4 != null) {
    const rotateImg = function (entries, observer) {
        const [entry] = entries
        var img1 = section4.querySelector('.sec4_content:first-child .right_img_content')
        var img2 = section4.querySelector('.sec4_content:last-child .right_img_content')
        if (entry.isIntersecting === true && window.innerWidth > 980) {
            window.addEventListener('scroll', function (e) {
                var scroll = this.window.scrollY;
                img1.style.transform = `rotate(${(scroll - 3500) * 0.01}deg)`
                img2.style.transform = `rotate(-${(scroll - 3500) * 0.01}deg)`
            })
        }
        else if (entry.isIntersecting === false) {
            img1.style.transform = `rotate(0deg)`
            img2.style.transform = `rotate(-0deg)`
        }
    }
    
    
    const Imgobserver = new IntersectionObserver(rotateImg, {
        root: null,
        threshold: 0,
        rootMargin: '-20%'
    })
    
    Imgobserver.observe(section4);    
}



// Rotate

var img1Box = document.querySelector('.img_content .single_img_box:first-child')
var img2Box = document.querySelector('.img_content .single_img_box:nth-child(2)')
var img3Box = document.querySelector('.img_content .single_img_box:last-child')
if (img1Box) {
    window.addEventListener('scroll', function (e) {
        var scroll = this.window.scrollY
        var img1 = img1Box.querySelector('.img_span')
        var img2 = img2Box.querySelector('.img_span')
        var img3 = img3Box.querySelector('.img_span')
    
        img1.style.transform = `rotate(${(scroll - 850) * 0.02}deg)`
        // img2.style.transform = `scale(${(scroll - 700)})`
        // img2.style.transform = `scale(${(scroll - 700) * 0.08})`
        img3.style.transform = `rotate(-${(scroll - 850) * 0.02}deg)`
    });    
}



//  sec6_img rotate

var img6Box = document.querySelector('.home_section6 .img_box');
if (img6Box) {
    window.addEventListener('scroll', function () {
        var scroll = this.window.scrollY
        // console.log(this.window.scrollY);
        img6Box.style.transform = `rotate(${(scroll - 5500) * 0.009}deg)`
    });    
}



var btn = document.querySelector(".ignoreBtn")
if (btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault()
        btn.closest('.bottom_notice_banner').style.display = 'none'
    });    
}


// arrow:= move to top

var moveBtn = document.querySelector('.arrow_container');
if (moveBtn) {
    moveBtn.addEventListener('click', function () {
        window.scrollTo({
            top: 0
        })
    });   

    window.addEventListener('scroll', function () {
        if (this.window.scrollY > 800) {
            moveBtn.classList.add('show')
        }
        else moveBtn.classList.remove('show')
    });
}


// magnific Popup
$('.with-caption').magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    closeBtnInside: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
        verticalFit: true,
        titleSrc: function (item) {
            return item.el.attr('title');
        }
    },
    zoom: {
        enabled: true 
    }
});

if (document.querySelector("#sort_select")) {
    document.querySelector("#sort_select").addEventListener("change", function(){
        window.location.href = this.value;
    });
}

function updadeajax(input){
    var loop = 0;
    var text = input.value.toLowerCase();
    document.querySelectorAll("#product-grid a").forEach(function(a){
        var href = a.getAttribute("data-title").toLowerCase();
        if (href.includes(text)) {
            a.style.display = "block";
            loop = loop+1;
        }
        else
        {
            a.style.display = "none";
        }

        if (text == "") {
            a.style.display = "block";
            loop = 0;
        }
    });

    if (loop == 0 && text == "") {
        document.querySelector("#ProductCountDesktop").textContent = document.querySelectorAll("#product-grid a").length + ' produits';
    }
    else
    {
        document.querySelector("#ProductCountDesktop").textContent = loop + ' produits';
    }
}

if (document.querySelector("#collection_search")) {
    
    document.querySelector("#collection_search").addEventListener("keyup", function(){
        updadeajax(this)
    });
}


function updatepage(url){
    fetch(url).then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector('.collection_main_box .right_product_box').innerHTML =  doc.querySelector(".collection_main_box .right_product_box").innerHTML;
        document.querySelector('.product-count').innerHTML =  doc.querySelector(".product-count").innerHTML;
        document.querySelector('#FacetFiltersForm').innerHTML =  doc.querySelector("#FacetFiltersForm").innerHTML;
        
        updadeajax(document.querySelector("#collection_search"));
    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
}


document.querySelectorAll(".product_type li a").forEach(function(link){
    link.addEventListener("click", function(e){
        e.preventDefault();
        var url = link.getAttribute("href");
	    window.history.pushState("", "", url);
        updatepage(url)
    })
});

document.querySelectorAll(".product_type li a").forEach(function(link){
    var href = link.getAttribute("href").split("?")[0] + (window.location.href.split("?")[1] ? '?' + window.location.href.split("?")[1]: '');
    link.setAttribute("href", href);
});